/**
 * Membership = the user holds at least one DB role (estimator, reviewer,
 * admin, ...). Role-less accounts are pay-per-conversion users: they get the
 * full app shell but only the PDF import + ESX export feature set (incl. the
 * free Sketch export); Scope Builder, AI Chat, and Scope Enhancement are locked
 * (the backend enforces the same rule server-side via require_member).
 */
import useAuthStore from '../stores/authStore';

/** True once roles have loaded AND the user holds at least one role. */
export function useIsMember(): boolean {
  return useAuthStore((s) => s.rolesLoaded && s.roles.length > 0);
}

/**
 * True once roles have loaded AND the user holds NO roles (pay-per user).
 * A FAILED roles fetch does not count: "couldn't find out" must not trigger
 * the pay-per surface (credits bootstrap, forced V2) for a possible member.
 */
export function useIsPayPerUser(): boolean {
  return useAuthStore(
    (s) => s.rolesLoaded && !s.rolesFetchFailed && s.roles.length === 0,
  );
}
